import PropTypes from 'prop-types';
import React, { Component } from 'react';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { selectPreferences, selectFeatureFlags } from '../../selectors/ContextSelector';
import FinalPriceAfterCoupon from '../FinalPriceAfterCoupon/FinalPriceAfterCoupon';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import EcoRebatesNew from '../EcoRebates/EcoRebatesNew';
import productPricingSelector, {
    pickupDiscountSelector,
} from '../../selectors/ProductPricingSelector';
import selectPricingFallbackCallError from '../../selectors/pricing/selectPricingFallbackCallError';
import productFinalPriceAfterCoupon from '../../selectors/ProductFinalPriceSelector';
import { initProductOptions } from '../../selectors/ProductOptionsSelector';
import { selectRebateInfoBySource } from '../../selectors/PdpNameSpaceSelector';
import FinalPriceWithPickupDiscount from '../FinalPriceWithPickupDiscount/FinalPriceWithPickupDiscount';
import ProductConstants from '../../common/ProductConstants';

export class SpecialOffers extends Component {
    static propTypes = {
        couponPriceDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        featureFlags: PropTypes.object,
        pricingDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        pricingFallbackCallError: PropTypes.bool,
        productOptions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        fromMiniPDP: PropTypes.bool,
        deviceType: PropTypes.object,
        deliveryOptionsName: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        pickupDiscount: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        preferences: PropTypes.oneOfType([PropTypes.object]),
        filteredItems: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    };

    static defaultProps = {
        couponPriceDetails: [],
        featureFlags: {},
        pricingDetails: {},
        pricingFallbackCallError: false,
        productOptions: {},
        fromMiniPDP: false,
        deviceType: {},
        deliveryOptionsName: {},
        pickupDiscount: {},
        preferences: {},
        filteredItems: {},
    };

    state = {
        isRebatesAvailable: null,
    };

    isRebatesEligible = (isRebatesAvailable) => {
        this.setState({ isRebatesAvailable });
    };

    render() {
        const {
            productOptions: { isProductInStock },
            featureFlags: { enableBopisIncentive, enableEcoRebateNew = false },
            couponPriceDetails,
            pricingDetails,
            pricingFallbackCallError,
            fromMiniPDP,
            deviceType,
            pickupDiscount,
            deliveryOptionsName,
            couponExclusionMessage,
            filteredItems,
        } = this.props;
        const { isRebatesAvailable } = this.state;

        const { min, max } = get(couponPriceDetails, 'couponInfo[0].amount', {});
        let couponAmount = null;
        /* istanbul ignore else  */
        if (min && max && min === max) {
            couponAmount = min.toLocaleString('en', { minimumFractionDigits: 2 });
        }

        const price = pricingDetails.defaults || pricingDetails.original;
        const isMapPrice = pricingDetails.mapPrice;
        const promotions = pricingDetails.promotions || [];
        /* istanbul ignore next  */
        const isDisplayFPAC =
            isProductInStock && couponAmount && !(pricingFallbackCallError || price === '$0');
        const isPromotionalLabel = promotions.length && !pricingDetails.mapPrice;
        const displaySplOfferContainer = !!(
            isDisplayFPAC ||
            (isRebatesAvailable !== null && isRebatesAvailable) ||
            (isPromotionalLabel && !deviceType.isDesktop)
        );
        const bopisIncentiveEligible =
            enableBopisIncentive &&
            !isEmpty(pickupDiscount) &&
            !couponAmount &&
            !isMapPrice &&
            deliveryOptionsName.selectedOption === ProductConstants.BOPIS_SELECTED_OPTION &&
            deliveryOptionsName.isSelectedItemBopisAvailable;

        const borderStyle =
            isEmpty(couponExclusionMessage) && (isDisplayFPAC || bopisIncentiveEligible)
                ? ['border-b', 'border-solid', 'border-gray-15', 'py-2']
                : [];
        const ecoRebatebBorderStyle =
            borderStyle?.length > 0 ? [] : ['border-b', 'border-solid', 'border-gray-15'];
        return (
            <section className={dt([...borderStyle])}>
                {isDisplayFPAC ? (
                    <ErrorBoundary>
                        <FinalPriceAfterCoupon
                            displayDetailsLink
                            fromMiniPDP={fromMiniPDP}
                            couponAmount={couponAmount}
                            showPayOnly
                        />
                    </ErrorBoundary>
                ) : null}

                {bopisIncentiveEligible ? (
                    <ErrorBoundary>
                        <FinalPriceWithPickupDiscount pickupDiscount={pickupDiscount} />
                    </ErrorBoundary>
                ) : null}
                {enableEcoRebateNew && filteredItems[0]?.rebatesAvailable && (
                    <ErrorBoundary>
                        <EcoRebatesNew
                            skuId={filteredItems[0]?.id}
                            fromMiniPDP={this.props.fromMiniPDP}
                            ecoRebatebBorderStyle={ecoRebatebBorderStyle}
                        />
                    </ErrorBoundary>
                )}
            </section>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    couponPriceDetails: productFinalPriceAfterCoupon(ownProps.fromMiniPDP)(state),
    featureFlags: selectFeatureFlags(state),
    pricingDetails: productPricingSelector(ownProps.fromMiniPDP)(state),
    pickupDiscount: pickupDiscountSelector(ownProps.fromMiniPDP)(state),
    pricingFallbackCallError: selectPricingFallbackCallError(state),
    productOptions: initProductOptions(ownProps.fromMiniPDP)(state),
    filteredItems: initProductOptions(ownProps.fromMiniPDP)(state).filteredItems,
    rebateInfo: selectRebateInfoBySource(ownProps.fromMiniPDP)(state),
    deliveryOptionsName: state.deliveryOptionsName,
    preferences: selectPreferences(state),
});

export default connect(mapStateToProps)(SpecialOffers);
